import { COLOR_PALETTE, Stack, Tabs, Title, VisuallyHidden } from '@inflearn/ds-react';
import { GAME_TYPE_CONFIG } from './types';

interface GameSelectorProps {
  children: React.ReactNode;
  value?: string;
  onTabChange?: (value: string | null) => void;
}

export const GameSelector = ({ children, value, onTabChange }: GameSelectorProps) => {
  return (
    <Stack>
      <VisuallyHidden>
        <Title order={2} size="h3" ta="center" mb={20}>
          게임 선택
        </Title>
      </VisuallyHidden>
      <Tabs
        value={value}
        onTabChange={onTabChange}
        defaultValue={GAME_TYPE_CONFIG.MOLE_ATTACK.title}
        variant="pills"
        radius="xl"
        orientation="vertical"
        styles={{
          tab: {
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
            color: COLOR_PALETTE.gray[9],
          },
          panel: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
          },
        }}
      >
        <Tabs.List px={20}>
          {Object.values(GAME_TYPE_CONFIG).map((config) => (
            <Tabs.Tab key={config.title} value={config.title}>
              {config.title}
            </Tabs.Tab>
          ))}
        </Tabs.List>
        {children}
      </Tabs>
    </Stack>
  );
};
